import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../AppIcon';

/**
 * Discord Source Indicator Component
 * Shows when a message came from Discord
 */
const DiscordIndicator = ({ message, className = '' }) => {
  if (message.source !== 'discord') return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      className={`inline-flex items-center space-x-1 text-[#7289DA] text-xs ${className}`}
      title="This message was sent from Discord"
    >
      <Icon name="MessageCircle" size={12} />
      <span className="font-medium">via Discord</span>
    </motion.div>
  );
};

export default DiscordIndicator;